import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  greetingMessage: {
    color: theme.palette.grey.grey00,
  },
}))

interface InstallerWelcomeMessageProps {
  firstName: string
  hasWelcomeMessage?: boolean
}

const EntryPointMessage: React.FC<InstallerWelcomeMessageProps> = ({ firstName, hasWelcomeMessage = true }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const greetingMessage = `${t('dashboard.installerWelcomeMesssage.greeting')} ${firstName}!`

  return (
    <Box className={classes.container} data-qa={'greeting-message'}>
      {hasWelcomeMessage && (
        <Typography variant="h1" className={classes.greetingMessage}>
          {greetingMessage}
        </Typography>
      )}
    </Box>
  )
}

export default EntryPointMessage
